import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { ReceiptStateFlowProps } from "models/propTypes/receiptPropTypes";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useReceiptService } from "serviceHooks";
//#endregion

const ReceiptStateFlow: React.FC<ReceiptStateFlowProps> = (props) => {
  const receiptService = useReceiptService();
  const { getMounted } = useMountedState();
  const { id } = props;

  const [states, setStates] = React.useState<WintSuperkollAPIModel.EntityStateLog[]>();

  React.useEffect(() => {
    receiptService.getStateLogs(id).then((items) => {
      if (getMounted()) {
        setStates(items);
      }
    });
  }, [id]);

  return <>{states && <LinearStateFlowContainer steps={states} translationKey={"Receipt.StateFlowState"} />}</>;
};

export default ReceiptStateFlow;
